import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=ea2d032c&scoped=true&"
import script from "./GoBack.vue?vue&type=script&lang=js&"
export * from "./GoBack.vue?vue&type=script&lang=js&"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=ea2d032c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2d032c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
